import axios from 'axios';

const runtime = window.__APP_CONFIG__?.API_BASE;
// Optional build-time fallback if you ever want it:
const build = process.env.REACT_APP_API_BASE;

// Final baseURL priority: runtime > build > derived (very last resort)
const derived = (() => {
    try {
        const host = window.location.hostname; // demo-performance.concisesolutions.co.za
        const parts = host.split('.');
        parts[0] = 'pms-backend';
        return `${window.location.protocol}//${parts.join('.')}`;
    } catch { return undefined; }
})();

const baseURL = build || runtime || derived;

const api = axios.create({
    baseURL,
    withCredentials: true,
    withXSRFToken: true,
});

api.defaults.headers.common['Accept'] = 'application/json';

api.interceptors.response.use(
    (res) => res,
    (err) => {
        const status = err?.response?.status;
        if (status === 401 && !window.location.pathname.startsWith('/login')) {
            const lastPath = window.location.pathname + window.location.search;
            sessionStorage.setItem('redirectAfterLogin', lastPath);
            window.location.assign('/login');
        }
        return Promise.reject(err);
    }
);

export default api;
